export const ModalModalityEnum = {
  Edit: "edit",
  Create: "create",
};

export const FileImportState = {
  upload: "upload",
  validation: "validation",
  digitalTwinShortcut: "digitalTwinShortcut",
  success: "success",
  error: "error",
};
